<template>
  <div>
    <general-table
      ref="generalTable"
      :api-url="apiUrl"
      :columns="columns"
      :type="type"
      :top-header="topHeader"
      :filter-payroll="true"
      :need-payroll-excel="true"
    >
      <template #cell(user)="data">
        <div class="d-flex py-1 ml-1">
          <div style="margin-right:10px ;">
            <b-avatar size="40" />
          </div>
          <div class="d-flex flex-column justify-content-start align-items-start">
            <span>{{ data.item.user.name }}</span>
            <span class="text-muted">{{ data.item.user.email }}</span>
          </div>
        </div>
      </template>

      <template #cell(office)="data">
        <div
          v-if="data.item.user.office.country"
          class="d-flex flex-column"
        >
          <span v-if="data.item.user.office.country">{{ data.item.user.office.country }}</span>
        </div>
      </template>

      <template #cell(department)="data">
        <div
          v-if="data.item.user.department"
          class="d-flex flex-column"
        >
          <span v-if="data.item.user.department.title.ar">{{ data.item.user.department.title.ar }}</span>
          <span v-if="data.item.user.department.title.en">{{ data.item.user.department.title.en }}</span>
        </div>
      </template>

      <template #cell(air_ticket_allowance)="data">
        <AddAirTicketAllowance
          :data-air-ticket="data"
          :get-all-data-pass="getAllDataPass"
        />
      </template>

      <template #cell(benefits)="data">
        <AddBenefits
          :data-benefits="data"
          :get-all-data-pass="getAllDataPass"
        />
      </template>

      <template #cell(bonus)="data">
        <AddBonus
          :data-bonus="data"
          :get-all-data-pass="getAllDataPass"
        />
      </template>

      <template #cell(incentive)="data">
        <AddIncentive
          :data-incentive="data"
          :get-all-data-pass="getAllDataPass"
        />
      </template>

      <template #cell(over_time_hours)="data">
        <AddOvertime
          :data-overtime="data"
          :get-all-data-pass="getAllDataPass"
        />
      </template>

      <template #cell(audit_days)="data">
        <AddAuditPeriod
          :data-audit="data"
          :get-all-data-pass="getAllDataPass"
        />
      </template>

      <template #cell(early_leave_hours)="data">
        <AddEarlyLeaveHours
          :data-early-leave-hours="data"
          :get-all-data-pass="getAllDataPass"
        />
      </template>

      <template #cell(remark)="data">
        <AddRemark
          :data-remark="data"
          :get-all-data-pass="getAllDataPass"
        />
      </template>

      <template #cell(skip_loan)="data">
        <div
          v-if="data.item.loan > 0"
          class="px-2"
        >
          <b-btn
            variant="outline-danger"
            size="sm"
            @click="handleSkipLoan(data.item)"
          >
            Skip Loan
          </b-btn>
        </div>
      </template>

    </general-table>
  </div>
</template>

<script>
import axios from 'axios'
import GeneralTable from '@/components/general-table/GeneralTable.vue'
import AddAirTicketAllowance from '@/views/payroll/controll-payroll/AddAirTicketAllowance.vue'
import AddBenefits from '@/views/payroll/controll-payroll/AddBenefits.vue'
import AddBonus from '@/views/payroll/controll-payroll/AddBonus.vue'
import AddIncentive from '@/views/payroll/controll-payroll/AddIncentive.vue'
import AddOvertime from '@/views/payroll/controll-payroll/AddOvertime.vue'
import AddAuditPeriod from '@/views/payroll/controll-payroll/AddAuditPeriod.vue'
import AddRemark from '@/views/payroll/controll-payroll/AddRemark.vue'
import AddEarlyLeaveHours from '@/views/payroll/controll-payroll/AddEarlyLeaveHours.vue'

export default {
  components: {
    GeneralTable,
    AddAirTicketAllowance,
    AddBenefits,
    AddBonus,
    AddIncentive,
    AddOvertime,
    AddAuditPeriod,
    AddRemark,
    AddEarlyLeaveHours,
  },
  data() {
    return {
      APIURL: `payroll/${this.$route.params.id}`,
      type: 'page',
      partners: [],
      filter: {},
      types: '',
      columns: [
        { key: 'user', label: 'Name & email' },
        { key: 'office', label: 'Office' },
        { key: 'department', label: 'Department' },
        { key: 'salary', label: '' },
        { key: 'over_time_salary', label: 'Salary' },
        { key: 'over_time_hours', label: 'Hours' },
        { key: 'audit_salary', label: 'Salary' },
        { key: 'audit_days', label: 'Days' },
        { key: 'early_leave_deduction', label: 'Salary' },
        { key: 'early_leave_hours', label: 'Hours' },
        { key: 'reimbusement_expenses', label: '' },
        { key: 'leave_days', label: 'leave days' },
        { key: 'loss_of_leave', label: 'loss of pay' },
        { key: 'air_ticket_allowance', label: '' },
        { key: 'benefits', label: '' },
        { key: 'bonus', label: '' },
        { key: 'incentive', label: '' },
        { key: 'loan', label: 'loan' },
        { key: 'pension', label: 'pension' },
        { key: 'skip_loan', label: 'Skip Loan' },
        { key: 'net_salary', label: '' },
        { key: 'mode_of_payment', label: '' },
        { key: 'remark', label: '' },
      ],
      topHeader: [
        { lable: 'User', colspan: 3 },
        { lable: 'Fixed Salary', colspan: 1 },
        { lable: 'Over Time', colspan: 2 },
        { lable: 'Audit', colspan: 2 },
        { lable: 'Early Leave Hours', colspan: 2 },
        { lable: 'Reimbusement Expenses', colspan: 1 },
        { lable: 'Leave Days', colspan: 2 },
        { lable: 'Air Ticket Allowance', colspan: 1 },
        { lable: 'Benefits', colspan: 1 },
        { lable: 'Bonus', colspan: 1 },
        { lable: 'Incentive', colspan: 1 },
        { lable: 'Net Salary', colspan: 1 },
        { lable: 'Mode Of Payment', colspan: 1 },
        { lable: 'Remark', colspan: 1 },
      ],
    }
  },

  computed: {
    apiUrl() {
      let base = `payroll/${this.$route.params.id}?`

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      return base.slice(0, -1)
    },
  },

  methods: {
    async handleSkipLoan(item) {
      const payslipId = item.id
      const result = await this.$swal.fire({
        title: 'Skip loan?',
        text: 'Are you sure you want to skip loan for this payslip?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      })

      if (!result.isConfirmed) return

      try {
        await axios.patch(`payslip/${payslipId}/skip-loan`, {})
        this.$swal.fire('Done', 'Loan skipped successfully.', 'success')
        this.getAllDataPass()
      } catch (error) {
        this.$swal.fire('Error', 'Failed to skip loan. Please try again.', 'error')
      }
    },
    filterTypes(type) {
      const filteredType = this.status.filter(item => item.text !== type)
      this.types = filteredType
    },
    getAllDataPass(page) {
      this.$refs.generalTable.getAllData(page)
    },
  },
}
</script>

<style></style>
